export const Footer = () => {
  return (
    <footer className="bg-[#0D3D1F] text-white/80 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo-3aqarate.png" alt="3aqarate" className="h-14 w-auto bg-white rounded-xl p-1.5" />
            <div className="flex flex-col leading-none">
              <span className="font-heading font-medium text-xs tracking-[0.25em] uppercase text-[#F4B400]">Sans Frontières</span>
              <span className="text-[10px] text-white/50 tracking-[0.2em] uppercase mt-1">Marché Immobilier Maghreb</span>
            </div>
          </div>
          <p className="text-sm max-w-md leading-relaxed text-white/60">
            La marketplace immobilière de référence au Maghreb. Particuliers et professionnels publient en toute confiance leurs annonces au Maroc, en Algérie et en Tunisie.
          </p>
        </div>

        <div>
          <h4 className="font-heading font-medium mb-3 text-white">Pays</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li>🇲🇦 Maroc</li>
            <li>🇩🇿 Algérie</li>
            <li>🇹🇳 Tunisie</li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-medium mb-3 text-white">Liens</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li>Annonces</li>
            <li>Carte interactive</li>
            <li>Publier une annonce</li>
            <li>Pour les pros</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 text-xs text-white/40 flex justify-between">
          <span>© 2026 3aqarate · عقارات المغرب الكبير</span>
          <span className="hidden md:block">Made with care in the Maghreb</span>
        </div>
      </div>
    </footer>
  );
};
